import _ from 'lodash';
import * as React from 'react';

import { connectAnalytics } from './utilities/analytics';
import globals from '../PageBuilder/globals';
import Linking from '../PageBuilder/helpers/linking';

/*
This component should be thought of solely as a generic "link."
You probably shouldn't be writing any styles in this component.
*/

const RawLink = ({ href, onClick, children, forwardRef, ...props }) => {
  const opensInBlank = Linking.Parse(href)?.opensInBlank;
  const newProps = opensInBlank
    ? {
        ...props,
        target: '_blank',
        rel: 'noreferrer',
      }
    : props;

  // eslint-disable-next-line no-unused-vars
  const { dispatch, legacyTheme, ...cleanProps } = newProps;

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <a href={onClick ? null : href} onClick={onClick ? e => onClick?.(e) : null} ref={forwardRef} {...cleanProps}>
      {children}
    </a>
  );
};

const connectPageBuilderMetadata = Component =>
  // eslint-disable-next-line react/prefer-stateless-function
  class extends React.Component {
    render() {
      // eslint-disable-next-line prefer-const
      let { analytics, href, formUid, ...props } = this.props;
      const { PB_LINK_META } = globals();
      if (typeof PB_LINK_META !== 'undefined' && href)
        analytics = _.merge({}, PB_LINK_META[href]?.analytics, analytics || {});
      if (typeof PB_LINK_META !== 'undefined' && formUid)
        analytics = _.merge({}, PB_LINK_META[formUid]?.analytics, analytics || {});
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <Component analytics={analytics} href={href} {...props} />;
    }
  };

const Link = connectPageBuilderMetadata(connectAnalytics(RawLink));

export default Link;
